import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { LoginService } from '../home/login.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ProductService } from '../products/products.service';
import { AppComponent } from '../app.component';
import { PasswordValidation } from '../account/password-validation';
import { Subscription } from 'rxjs';
import { IRep } from '../home/rep';
import { ToastrService } from 'ngx-toastr';
import { APIResult } from '../home/apiResult';
import { IRepPublicData } from '../home/repPublicData';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  standalone: false,
    templateUrl: './passwordreset.component.html'
})
export class PasswordResetComponent implements OnInit {
    public pageTitle: string = 'Password Reset';
    rep!: IRepPublicData;
    public apiResult!: APIResult;
    errorMessage!: string;
    private sub!: Subscription;
    public caption: string;
    public transErrMsg: string;
    translatedText = '';

    constructor(private _loginService: LoginService, public fb: FormBuilder, private _productService: ProductService, private _route: ActivatedRoute,
        private _router: Router, public app: AppComponent, private toaster: ToastrService,
        public translate: TranslateService, public admin: AdminService, public spinner: NgxSpinnerService) {
    }
    public resetForm = this.fb.group({
        custEmail: ['', Validators.compose([Validators.required, Validators.email])]
    });
    public options = {
        position: ["bottom", "right"],
        timeOut: 6000,
        lastOnBottom: true,
        preventDuplicates: false,
        preventLastDuplicates: false
    };

    getLocale(): any {
        var currentLocale = localStorage.getItem('locale');
        return currentLocale;
    }
    googleTranslateCall(textToTrans: string, targetLang: string): string {
        let model =
        {
            "q": [textToTrans],
            "target": targetLang
        };
        this.admin.googleTranslate(model).subscribe((response: any) => {
            //console.log('Translate Call: ' + response.data.translations[0].translatedText);
            this.translatedText = response.data.translations[0].translatedText;
            return this.translatedText;
        });
        return '';
    }
    showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
        //use this for dynamic error messages
        if (staticErrorMsg === false) {
            let locale = this.getLocale();
            if (locale !== 'en') {

                //were gonna do it nested, couldn't do it as a standalone method.
                let model =
                {
                    "q": [errorMessage],
                    "target": locale
                };

                this.admin.googleTranslate(model).subscribe((response: any) => {

                    let res = response.data.translations[0].translatedText as string;
                    this.translatedText = response.data.translations[0].translatedText as string;
                    this.transErrMsg = this.translatedText;
                    localStorage.setItem('translatedText', res);


                }, error => console.log(error), () => {

                    this.translate.get(subject).subscribe((res: string) => {
                        this.caption = res;
                        console.log(res);
                    }, error => console.log(error), () => {
                        this.spinner.hide();
                        //once the caption is translated, fire off the toaster popup
                        this.toaster.error(this.transErrMsg, this.caption, {
                            timeOut: 5000
                        });
                        localStorage.removeItem('translatedText');

                    });
                });



                //this.transErrMsg =  this.translatedText;
            }
            else {
                this.translate.get(subject).subscribe((res: string) => {
                    this.caption = res;
                    console.log(res);
                }, error => console.log(error), () => {
                    this.transErrMsg = errorMessage;
                    this.spinner.hide();
                    //once the caption is translated, fire off the toaster popup
                    this.toaster.error(this.transErrMsg, this.caption, {
                        timeOut: 5000
                    });
                    localStorage.removeItem('translatedText');
                });
            }
        }
        else {
            // translate the error message - not dynamic
            this.translate.get(errorMessage).subscribe((res: string) => {
                this.transErrMsg = res;
                console.log(res);
            });

            // translate the caption
            this.translate.get(subject).subscribe((res: string) => {
                this.caption = res;
                console.log(res);
            });
            this.spinner.hide();
            //show the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {

                timeOut: 5000
            });
        }
    }
    reset(): any {
        this._loginService.sendResetEmail(this.resetForm.controls.custEmail.value)
            .subscribe(res => {
                this.apiResult = res
            }, error => this.showError("passwordReset.toastPopup.errors.resetError", "passwordReset.toastPopup.errors.title.resetError", true), () => {
                this.resetSuccess("passwordReset.toastPopup.success.resetSuccess", "passwordReset.toastPopup.titles.resetPass");
                // this._loginService.getCustomerDID(this.resetForm.controls.custEmail.value)
                // .subscribe(rep => this.rep = rep, error => this.resetError(), () =>{
                //     this.resetSuccess();
                // })

                //when successful do this stuff

                // setTimeout((router: Router) => {
                //     this._router.navigateByUrl('validate/from/' + this.repId());
                // }, 2000);

            });
    }
    // resetError(): void {

    //     this.toaster.error("Please enter a valid email address.", "Failed to Send",  {
    //         timeOut: 3000
    //     });
    // }

    resetSuccess(message: string, caption: string): void {
        // translate the error message - not dynamic
        this.translate.get(message).subscribe((res: string) => {
            this.transErrMsg = res;
            console.log(res);
        });

        // translate the caption
        this.translate.get(caption).subscribe((res: string) => {
            this.caption = res;
            console.log(res);
        });
        this.toaster.success(this.transErrMsg, this.caption, {
            timeOut: 3000
        });

    }

    repId(): any {
        var currentId = localStorage.getItem('repId');
        return currentId;
    }

    ngOnInit(): void {
        // this._loginService.refreshToken()
        // .subscribe()

        this.sub = this._route.params.subscribe(
            params => {
                let id = +params['id'];
                this._productService.getRepInfo(id.toString()).subscribe(rep => {
                    this.rep = rep;
                    this.app.rep = rep;
                });
                localStorage.setItem('repId', id.toString());

            });
    }
}
